<div class="userLogsPage" *ngIf="true">
  <div class="container-component">
        <user-logs-list class="userLogs-list"></user-logs-list>
    </div>
</div>
<div *ngIf="false ">
  <br><br><br><br>
  <h1 class="error">User not Authorized to enter this page</h1>
</div>